//https://regexr.com/68j0p

function validateGreekPhoneNumber(phoneNumber: string) {
  return phoneNumber.match(/^[0-9]{10}$/gi);
}

export default validateGreekPhoneNumber;
